/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MedWheelchairIcon16Solid = forwardRef('MedWheelchairIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7 4.266a2.25 2.25 0 1 0-2 0V8.5A1.5 1.5 0 0 0 6.5 10h3.882l1.724 3.447c.243.487.854.691 1.341.447l1.5-.75a1 1 0 1 0-.894-1.788l-.606.302-1.414-2.829A1.5 1.5 0 0 0 10.69 8H7V7h3a1 1 0 1 0 0-2H7v-.734Z" }),
        React.createElement("path", { d: "M3.667 7.391a1 1 0 1 0-1.334-1.49 5.5 5.5 0 1 0 7.944 7.557A1 1 0 1 0 8.723 12.2 3.5 3.5 0 1 1 3.667 7.39Z" })));
});
